<template>
  <div class="member-page">
    <div
      class="nav-bar"
      :style="{
        paddingTop: statusBarHeight + 'px',
        height: statusBarHeight + tabBarHeight + 'px'
      }"
    >
      <div class="back iconfont icon-fanhui" @click="bindBack"></div>
      <div class="title">会员故事</div>
      <div class="more" @click="bindMore">更多故事</div>
    </div>
    <van-swipe
      v-if="pageData && pageData.list"
      class="my-swipe"
      :autoplay="5000"
      :stop-propagation="false"
      indicator-color="white"
      :loop="false"
    >
      <van-swipe-item v-for="(item, index) in pageData.list" :key="index">
        <div class="swipe-item-content">
          <div class="swipe-item-scroll" ref="scroll">
            <div>
              <img class="swipe-image" :src="item.image" alt="" />
            </div>
          </div>
          <div class="btn" @click.stop="bindDetail(item)">了解详情</div>
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      tabBarHeight: 0,
      statusBarHeight: 0,
      pageData: null
    }
  },
  created() {
    this.getBottomContentHeight()
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await this.$http
        .getBaseApp('api/v1/BaseConfig/getStaticByAction', {
          resource_action: 'JIANMENG_MEMBER_STORIES'
        })
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          if (res.data) {
            try {
              let data = JSON.parse(res.data)
              data.list.sort((a, b) => {
                return a.id - b.id
              })
              this.pageData = data
            } catch (error) {
              this.$toast('数据错误')
            }
          }
        } else {
          this.$toast(res.msg)
        }
      }
    },
    async getBottomContentHeight() {
      if (this.$betterwe.isApp()) {
        let res = await this.$betterwe.getAppBarHeight().catch(() => {})
        if (res) {
          this.tabBarHeight = res.toolsBarHeight
          this.statusBarHeight = res.statusBarHeight
        }
      } else {
        this.tabBarHeight = 40
        this.statusBarHeight = 20
      }
    },
    bindBack() {
      this.$http.appBack()
    },
    bindMore() {
      let url = this.pageData?.more
      if (url) {
        this.$betterwe.jumpRoute(
          `/web?url=${encodeURIComponent(url)}&title=${encodeURIComponent(
            '会员故事'
          )}`
        )
      }
    },
    bindDetail(item) {
      if (item.detail) {
        this.$betterwe.jumpWeb(item.detail)
      } else {
        this.$toast('跳转不能为空')
      }
    }
  }
}
</script>
<style lang="scss">
body,
html {
  overscroll-behavior: none;
}
</style>
<style lang="scss" scoped>
.member-page {
  height: 100vh;
  background-color: #050b27;
  .nav-bar {
    z-index: 5;
    box-sizing: border-box;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    padding: 0px 20px 0px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .back {
      padding: 10px;
      color: #fff;
      font-size: 20px;
    }
    .title {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      text-align: left;
      font-family: MiSans;
      font-weight: bold;
      font-size: 20px;
      color: #ffffff;
      line-height: 27px;
    }
    .more {
      font-weight: bold;
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
    }
  }
}
.my-swipe {
  height: 100vh;
  ::v-deep .van-swipe__indicator {
    width: 20px;
    height: 4px;
    background: #ffffff;
    opacity: 0.2;
    border-radius: 0;
  }
  ::v-deep .van-swipe__indicator--active {
    opacity: 1;
  }
  ::v-deep .van-swipe__indicators {
    z-index: 999;
    bottom: 108px;
  }
  .swipe-item-content {
    position: relative;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    .swipe-item-scroll {
      height: 100%;
      overflow-y: scroll;
      overscroll-behavior: none;
    }
    .btn {
      position: absolute;
      z-index: 1;
      width: 335px;
      height: 48px;
      background: linear-gradient(178deg, #ff2270 0%, #dc0050 100%);
      box-shadow: 0px 4px 4px 0px rgba(60, 16, 32, 0.1);
      border-radius: 24px;
      left: 50%;
      bottom: 44px;
      transform: translate(-50%, 0%) translateZ(0px);
      font-weight: bold;
      font-size: 16px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .swipe-image {
    width: 100%;
  }
}
</style>
